import axios from "axios";
import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { error } from "jquery";
import toastr from "../../../utils/toast";


function AddFeedback({ onClose, user_id, designation_id, year, onSuccess }) {
const { register, handleSubmit, reset, watch, setValue, formState:{ errors } } = useForm();
const navigate = useNavigate();
const { setGlobalLoading, token } = useOutletContext();
const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const CURRENCY_API_KEY = process.env.REACT_APP_CURRENCY_API_KEY;
const [designationType, setDesignationType] = useState(0);

  const [parameters, setParameters] = useState([]);
  const [data, setData] = useState([]);
  const [kraScores, setKraScores] = useState([]);
  const [autoRating, setAutoRating] = useState(null);

useEffect(() => {
  if (!user_id || !designation_id || !data.length) return;

  const init = async () => {
    // ✅ Set selected employee
    setValue("employee_id", String(user_id));

    // ✅ Fetch KRA directly using designation_id
    const kraData = await fetchKRAbyDesignation(designation_id);

    // ✅ Load existing feedback
    await fetchExistingFeedback(user_id);

  };

  init();
}, [user_id, designation_id, data]);

  useEffect(() => {
    fetchPerformers();
  }, [user_id, year]);

 const fetchPerformers = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_BASE_URL}/performance/self_performers`,
          {
            params: { user_id: user_id, year: year },
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const d = response.data;
        const team = d.team || [];
        console.log(team);
        setData(team);
      } catch (err) {
        console.error(err);
      }
    };
  const handleEmployeeChange = async (e) => {
    
    const selectedUserId = e.target.value;
    const selectedEmployee = data.find((emp) => String(emp.id) === String(selectedUserId));
    const fallbackDesignation = e.target.options[e.target.selectedIndex].getAttribute("data-designation");
    const desId = parseInt(selectedEmployee?.designation_id || fallbackDesignation, 10);
    reset();
    setValue("employee_id", selectedUserId);

    const kraData = await fetchKRAbyDesignation(desId); // ✅ get fresh data
    await fetchExistingFeedback(selectedUserId);
  };
  
  const fetchKRAbyDesignation = async (designation_id) => {
    try {
      const res = await axios.get(
        `${REACT_APP_API_BASE_URL}/performance/self_kra_by_designation`,
        {
          params: {
            designation_id,
            year: year,
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const kraData = res.data.parameters || [];

    setParameters(kraData);
    return kraData;
    } catch (err) {
      console.error(err);
    }
  };

  const fetchExistingFeedback = async (employeeId) => {
    try {
      const res = await axios.get(
        `${REACT_APP_API_BASE_URL}/performance/self_get_feedback`,
        {
          params: {
            employee_id: employeeId,
            year: year,
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const { review, ratings } = res.data;

      // ❌ No existing data → reset form
      if (!review) {
        setValue("overall_comments", "");
        return;
      }

      // ✅ Set overall comments
      setValue("overall_comments", review.overall_comments);

      // ✅ Set ratings dynamically
      Object.entries(ratings).forEach(([paramId, r]) => {
        setValue(`ratings.${paramId}.rating`, r.rating);
        setValue(`ratings.${paramId}.comments`, r.comments);
      });

    } catch (err) {
      console.error("Error fetching feedback:", err);
    }
  };

  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);

      const cleanedRatings = Object.fromEntries(
      Object.entries(data.ratings || {}).filter(([_, v]) => v && v.rating)
    );

    data.ratings = cleanedRatings;

    await axios.post(
        `${REACT_APP_API_BASE_URL}/performance/self_add_new_feedback`,
        data, // ✅ send JSON directly
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toastr.success("Self-Assessment submitted successfully!");
      onSuccess?.();
      onClose();
    } catch (err) {
      console.error("Submission failed:", err);
      toastr.error("Error submitting feedback");
    } finally {
      setGlobalLoading(false);
    }
  };

return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-md" role="document" style={{ maxWidth: "650px" }}>
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">Final Year Self Assessment</h4>
                <input type="hidden" {...register("user_id")} />
              <button onClick={() => onClose()} type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ textAlign: "left"}}>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="mb-2">
                        <label className="form-label">Performer *</label>
                        <input type="hidden" name="reviewed_by" {...register("reviewed_by")} value={user_id} />
                        <input type="hidden" name="year" {...register("year")} value={year} />
                        <select
                          className={`form-select ${errors.roletype_id ? "is-invalid" : ""}`} disabled
                          {...register("employee_id", {
                            required: true,
                            onChange: (e) => handleEmployeeChange(e),
                          })}
                        >
                          <option value="">Select Employee</option>
                          {data?.map((item) => (
                            <option key={item.id} value={item.id} data-designation={item.designation_id}>
                              {item.has_self_review ? "✅ " : "⏳ "}
                              {item.employee_name} - {item.designation}
                            </option>
                          ))}
                        </select>
                        </div>

                       {Array.isArray(parameters) && parameters.length > 0 &&
                          parameters
                          .map((param) => {
                            const points = param.description
                              ? param.description.split("|").map((p) => p.trim())
                              : [];

                            return (
                              <div key={param.id} className="mb-3 border rounded p-3">

                                {/* Title */}
                                <h6>{param.name}</h6>

                                {/* Description as BULLETS */}
                                {points.length > 0 && (
                                  <ul
                                    className="text-muted mb-2 ps-3"
                                    style={{ listStyleType: "disc", paddingLeft: "20px" }}
                                  >
                                    {points.map((point, index) => (
                                      <li key={index}
                                          dangerouslySetInnerHTML={{ __html: point }}
                                        ></li>
                                    ))}
                                  </ul>
                                )}

                                {/* Rating */}
                                <label className="fs-12 form-label">Rating (1-5)</label>
                                <select
                                  className="form-select mb-2"
                                  {...register(`ratings.${param.id}.rating`, { required: true })}
                                >
                                  <option value="">Rate</option>
                                  {[1, 2, 3, 4, 5].map((r) => (
                                    <option key={r} value={r}>{r}</option>
                                  ))}
                                </select>

                                {/* Comments */}
                                <label className="fs-12 form-label">Comments</label>
                                <textarea
                                  className="form-control mb-2"
                                  placeholder={`Comments on ${param.name}`}
                                  {...register(`ratings.${param.id}.comments`)}
                                />

                              </div>
                            );
                          })
                        }
                        {Array.isArray(parameters) && parameters.length > 0 && (
                          <div className="mb-2">
                            <label className="form-label">Overall Comments *</label>
                            <input
                              type="text"
                              {...register("overall_comments")}
                              className={`form-control ${errors.address && "is-invalid"}`}
                            />
                          </div>
                        )}
                        
                    </div>
                </div>
            </div>
            <div className="modal-footer">
              <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">
                Close
              </button>
              <button type="submit" className="btn btn-primary ms-2">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>  
);    
}
export default AddFeedback;